import { string } from 'yup'
import { safify } from '../utils/safify'

export const website = string()
  .default('')
  .meta({
    label: 'Enter the website for your company',
    placeholder: 'www.example.com',
  })
  .transform(safify)
